<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-12">
          <h2
            class="text-center text-md-left primary--text d-flex align-center"
          >
            <v-icon class="primary--text mr-2" size="32">monetization_on</v-icon
            >{{$t('patientFinancial.title')}}
          </h2>
        </v-col>
      </v-row>
      <hr class="primary--lightGray mt-3" />
      <v-col class="col-12">
        <v-row>
          <p class="primary--lightGray schedule-text mt-3">
            {{$t('patientFinancial.subtitle')}}
          </p>
        </v-row>
      </v-col>
      <v-row v-if="!redoForm" align="start" justify="space-between">
        <v-col
          class="col-12 d-flex flex-column flex-md-row align-center justify-center"
        >
          <v-row align="center" justify="end">
            <v-col class="col-12 col-md-5 col-xl-4 pt-0">
              <v-text-field
                hide-details
                solo
                v-model="dataSearch.name"
                label="Busque pelo nome do psicólogo"
                required
                background-color="#fff"
              ></v-text-field>
            </v-col>
            <v-col class="col-12 col-md-2 pt-0">
              <DatePicker
                label="Data de início"
                :isFlat="false"
                background="#fff"
                :isRequired="false"
                @date="saveDate($event, 'beginningDate')"
              />
            </v-col>
            <v-col class="col-12 col-md-2 pt-0">
              <DatePicker
                label="Data fim"
                :isFlat="false"
                background="#fff"
                :isRequired="false"
                @date="saveDate($event, 'finishDate')"
              />
            </v-col>
            <v-col class="col-12 col-md-4 pt-0 text-center text-md-right">
              <v-btn
                color="primary"
                class="lato-black white--text text-transform-none br-10 ml-md-5 mt-md-0"
                height="40"
                width="140"
                @click="clearForm"
              >
                Limpar filtro
              </v-btn>
              <v-btn
                color="secondary"
                class="lato-black white--text text-transform-none br-10 ml-5"
                height="40"
                width="140"
                @click="getAllAppointments"
              >
                Filtrar
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <div class="text-center" v-if="isLoading">
        <p>Carregando...</p>
        <v-progress-circular
          indeterminate
          color="primary"
          class="mb-0"
        ></v-progress-circular>
      </div>

      <v-row v-if="!isLoading && !placeholder">
        <v-col
          v-for="(item, index) in appointments"
          :key="index"
          class="col-12 col-md-6 col-lg-4"
        >
          <v-list class="py-0">
            <AppointmentRecordItem
              mode="patient"
              :appointmentData="item"
            />
          </v-list>
        </v-col>
      </v-row>

      <v-row v-if="!placeholder" class="justify-center">
        <v-col class="col-12 col-md-4">
          <v-row>
            <v-col class="col-12">
              <div
                class="d-flex yellow flex-row align-center justify-space-between pa-3 title"
              >
                <p class="ma-0 secondary--text">Total do Período</p>
                <p class="ma-0 secondary--text d-flex align-center">
                  <v-icon class="secondary--text mr-2">monetization_on</v-icon>
                  {{
                    totalValue.toLocaleString('pt-PT', {
                      style: 'currency',
                      currency: 'EUR',
                    })
                  }}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col class="col-12 col-md-6">
          <div class="no-schedule pa-3" v-if="placeholder">
            <v-icon
              x-large
              color="gray"
              style="font-size: 80px; padding-bottom: 10px"
              >sentiment_very_dissatisfied</v-icon
            >
            <p class="subtitle-1" style="color: #6f6f6f; font-weight: bold">
              Não encontramos nenhum dado.
            </p>
          </div>
        </v-col>
      </v-row>
      <div class="text-center" v-if="!isLoading && !placeholder">
        <v-pagination v-model="pageSearch" :length="lengthPage"></v-pagination>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import generalService from '../../services/general';
import AppointmentRecordItem from '@/components/AppointmentRecordItem';
import DatePicker from '@/components/DatePicker';

export default {
  data() {
    return {
      appointments: [],
      pageSearch: 1,
      lengthPage: 1,
      isLoading: false,
      redoForm: false,
      placeholder: false,
      totalValue: 0,
      dataSearch: {
        name: '',
        initialDate: '',
        finalDate: '',
        page: 1,
      },
    };
  },
  components: {
    AppointmentRecordItem,
    DatePicker,
  },
  mounted() {
    this.getAllAppointments();
  },
  watch: {
    pageSearch() {
      this.getAllAppointments();
    },
  },
  methods: {
    async getAllAppointments() {
      this.dataSearch.page = this.pageSearch;
      try {
        this.isLoading = true;
        const { data } = await generalService.getAppointmentsFilter(
          this.dataSearch,
        );
        if (data.results.length > 0) {
          this.lengthPage = Math.ceil(data.count / 12);
          this.appointments = data.results;
          this.totalValue = data.total_pt_value;
          this.placeholder = false;
        } else {
          this.placeholder = true;
        }
        console.log(this.appointments);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    saveDate(value, field) {
      console.log(value, field);
      if (field === 'beginningDate') {
        this.dataSearch.initialDate = value;
      } else {
        this.dataSearch.finalDate = value;
      }
    },
    clearForm() {
      this.redoForm = true;
      setTimeout(() => {
        this.dataSearch.name = '';
        this.dataSearch.initialDate = '';
        this.dataSearch.finalDate = '';
        this.getAllAppointments();
        this.redoForm = false;
      }, 10);
    },
  },
};
</script>

<style lang="css" scoped>
.custom-radius {
  border-radius: 30px;
}

.custom-radius__tag {
  border-radius: 0 30px 30px 0;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.obs-text {
  font-size: 0.8rem;
}

.no-schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}
</style>
